import NfcCardBatchModal from './NfcCardBatchModal';

export default NfcCardBatchModal;
